export default "__VITE_ASSET__DNt3j2zg__"